<template>
  <div>
    <v-row>
      <v-col cols="12">
        <h3>Verze</h3>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <h4>Software</h4>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="6">
        <v-row>
          <v-col cols="12">
            <h5>CTRL CPU - APP</h5>
          </v-col>

          <v-col cols="12" md="3">
            <v-text-field disabled readonly :label="$t('settings.swVersion.ecccu') + ': '" v-model="this.data.version"></v-text-field>
          </v-col>

          <v-col cols="12" md="3">
            <v-text-field disabled readonly :label="$t('settings.swVersion.inverter') + ': '" v-model="this.data.inverter.version"></v-text-field>
          </v-col>

          <v-col cols="12" md="3"> </v-col>
          <v-col cols="12" md="3"> </v-col>

          <template v-if="'bcu' in this.data">
            <v-col cols="12" md="3">
              <v-text-field disabled readonly :label="$t('settings.swVersion.bcu') + ': '" v-model="this.data.bcu.version"></v-text-field>
            </v-col>
          </template>

          <template v-if="'mppt' in this.data">
            <v-col cols="12" md="3" v-for="(item, index) in this.data.mppt" :key="index + 'C'">
              <v-row>
                <v-col cols="12">
                  <v-text-field disabled readonly :label="$t('settings.swVersion.mppt') + ' ' + (index + 1) + ': '" v-model="item.version"></v-text-field>
                </v-col>
              </v-row>
            </v-col>
          </template>

          <template v-if="'battery' in this.data">
            <v-col cols="12" md="3" v-for="(item, index) in this.data.battery.batteries" :key="index + 'D'">
              <v-row>
                <v-col cols="12">
                  <v-text-field disabled readonly :label="$t('settings.swVersion.dab') + ' ' + (index + 1) + ': '" v-model="item.version"></v-text-field>
                </v-col>
              </v-row>
            </v-col>
          </template>
        </v-row>
      </v-col>

      <v-col cols="6">
        <v-row>
          <v-col cols="12">
            <h5>CTRL CPU - Bootloader</h5>
          </v-col>

          <v-col cols="12" md="3">
            <template v-if="'versionBL' in this.data">
              <v-text-field disabled readonly :label="$t('settings.swVersion.ecccu') + ': '" v-model="this.data.versionBL"></v-text-field>
            </template>
            <template>
              <v-text-field disabled readonly :label="$t('settings.swVersion.ecccu') + ': '" value="0.0"></v-text-field>
            </template>
          </v-col>

          <v-col cols="12" md="3">
            <v-text-field disabled readonly :label="$t('settings.swVersion.inverter') + ': '" v-model="this.data.inverter.versionBL"></v-text-field>
          </v-col>

          <v-col cols="12" md="3"> </v-col>
          <v-col cols="12" md="3"> </v-col>

          <template v-if="'bcu' in this.data">
            <v-col cols="12" md="3">
              <v-text-field disabled readonly :label="$t('settings.swVersion.bcu') + ': '" v-model="this.data.bcu.versionBL"></v-text-field>
            </v-col>
          </template>

          <template v-if="'mppt' in this.data">
            <v-col cols="12" md="3" v-for="(item, index) in this.data.mppt" :key="index + 'E'">
              <v-row>
                <v-col cols="12">
                  <v-text-field disabled readonly :label="$t('settings.swVersion.mppt') + ' ' + (index + 1) + ': '" v-model="item.versionBL"></v-text-field>
                </v-col>
              </v-row>
            </v-col>
          </template>

          <template v-if="'battery' in this.data">
            <v-col cols="12" md="3" v-for="(item, index) in this.data.battery.batteries" :key="index + 'F'">
              <v-row>
                <v-col cols="12">
                  <v-text-field disabled readonly :label="$t('settings.swVersion.dab') + ' ' + (index + 1) + ': '" v-model="item.versionBL"></v-text-field>
                </v-col>
              </v-row>
            </v-col>
          </template>
        </v-row>
      </v-col>

      <v-col cols="6">
        <v-row>
          <v-col cols="12">
            <h5>SAFE CPU - APP</h5>
          </v-col>

          <v-col cols="12" md="3">
            <template v-if="'safety' in this.data">
              <v-text-field disabled readonly :label="$t('settings.swVersion.ecccu') + ': '" v-model="this.data.safety.version"></v-text-field>
            </template>
          </v-col>

          <v-col cols="12" md="3">
            <v-text-field disabled readonly :label="$t('settings.swVersion.inverter') + ': '" v-model="this.data.inverter.safety.version"></v-text-field>
          </v-col>

          <v-col cols="12" md="3"> </v-col>
          <v-col cols="12" md="3"> </v-col>

          <template v-if="'bcu' in this.data">
            <v-col cols="12" md="3">
              <v-text-field disabled readonly :label="$t('settings.swVersion.bcu') + ': '" v-model="this.data.bcu.safety.version"></v-text-field>
            </v-col>
          </template>

          <template v-if="'mppt' in this.data">
            <v-col cols="12" md="3" v-for="(item, index) in this.data.mppt" :key="index + 'G'">
              <v-row>
                <v-col cols="12">
                  <v-text-field disabled readonly :label="$t('settings.swVersion.mppt') + ' ' + (index + 1) + ': '" v-model="item.safety.version"></v-text-field>
                </v-col>
              </v-row>
            </v-col>
          </template>

          <template v-if="'battery' in this.data">
            <v-col cols="12" md="3" v-for="(item, index) in this.data.battery.batteries" :key="index + 'H'">
              <v-row>
                <v-col cols="12">
                  <v-text-field disabled readonly :label="$t('settings.swVersion.dab') + ' ' + (index + 1) + ': '" v-model="item.safety.version"></v-text-field>
                </v-col>
              </v-row>
            </v-col>
          </template>
        </v-row>
      </v-col>

      <v-col cols="6">
        <v-row>
          <v-col cols="12">
            <h5>SAFE CPU - Bootloader</h5>
          </v-col>

          <v-col cols="12" md="3">
            <template v-if="'safety' in this.data">
              <v-text-field disabled readonly :label="$t('settings.swVersion.ecccu') + ': '" v-model="this.data.safety.versionBL"></v-text-field>
            </template>
          </v-col>

          <v-col cols="12" md="3">
            <v-text-field disabled readonly :label="$t('settings.swVersion.inverter') + ': '" v-model="this.data.inverter.safety.versionBL"></v-text-field>
          </v-col>

          <v-col cols="12" md="3"> </v-col>

          <v-col cols="12" md="3"> </v-col>

          <template v-if="'bcu' in this.data">
            <v-col cols="12" md="3">
              <v-text-field disabled readonly :label="$t('settings.swVersion.bcu') + ': '" v-model="this.data.bcu.safety.versionBL"></v-text-field>
            </v-col>
          </template>

          <template v-if="'mppt' in this.data">
            <v-col cols="12" md="3" v-for="(item, index) in this.data.mppt" :key="index + 'I'">
              <v-row>
                <v-col cols="12">
                  <v-text-field disabled readonly :label="$t('settings.swVersion.mppt') + ' ' + (index + 1) + ': '" v-model="item.safety.versionBL"></v-text-field>
                </v-col>
              </v-row>
            </v-col>
          </template>

          <template v-if="'battery' in this.data">
            <v-col cols="12" md="3" v-for="(item, index) in this.data.battery.batteries" :key="index + 'J'">
              <v-row>
                <v-col cols="12">
                  <v-text-field disabled readonly :label="$t('settings.swVersion.dab') + ' ' + (index + 1) + ': '" v-model="item.safety.versionBL"></v-text-field>
                </v-col>
              </v-row>
            </v-col>
          </template>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: "StationVersions",
  props: {
    data: {
      type: Object,
      default: null,
      require: false,
    },
  },
};
</script>

<style scoped></style>
